import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { isDemo } from '@dreryk/demo-variant-frontend';

import { useDraftPrescriptionsWatch } from '../draftPrescriptions/DraftPrescriptionsForm.hooks';
import { DraftPrescriptionsFormController } from '../draftPrescriptions/DraftPrescriptionsForm.types';

import { HelpCenterBanner } from './HelpCenterStaticBanner';
import { PrescriptionsAdvertisementBanner } from './PrescriptionsAdvertisementBanner';

const MAX_PRESCRIPTIONS_COUNT_WITH_AD = 2;

type PrescriptionsBannerProps = Pick<DraftPrescriptionsFormController, 'control'> & {
   readonly sentPrescriptionsCount: number;
   readonly visitId: Visit['id'];
};

export const PrescriptionsBanner = (props: PrescriptionsBannerProps): JSX.Element | null => {
   const { length: draftPrescriptionsCount } = useDraftPrescriptionsWatch(props.control);
   const allPrescriptionsCount = props.sentPrescriptionsCount + draftPrescriptionsCount;
   const shouldPrescriptionsBannerVisible = allPrescriptionsCount <= MAX_PRESCRIPTIONS_COUNT_WITH_AD;

   if (!shouldPrescriptionsBannerVisible) {
      return null;
   }

   if (isDemo()) {
      return <HelpCenterBanner />;
   }

   return <PrescriptionsAdvertisementBanner visitId={props.visitId} allPrescriptionsCount={allPrescriptionsCount} />;
};
